export default __webpack_public_path__ + "static/media/calendar-2-times.06f79709.svg";